export default {
  methods: {
    getMeasurementPhases(measurement) {
      return this.wkbLibraryMeasurementsForms
        .filter((item) => item.measurement_id === measurement.id)
        .map((item) => item.phase);
    },
  },
};
